import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import SidebarBlocks from './SidebarBlocks';

const GridContainer = ({ sidebar, sidebarComponents, children }) => {
  const { position = 'left' } = sidebar;
  return (
    <Grid columns="equal" stackable>
      {position === 'left' && (
        <SidebarBlocks sidebar={sidebar} blockComponents={sidebarComponents} />
      )}
      <Grid.Column>{children}</Grid.Column>
      {position === 'right' && (
        <SidebarBlocks sidebar={sidebar} blockComponents={sidebarComponents} />
      )}
    </Grid>
  );
};

GridContainer.defaultProps = {
  sidebar: {},
  sidebarComponents: {},
};

GridContainer.propTypes = {
  children: PropTypes.node.isRequired,
  sidebar: PropTypes.object,
  sidebarComponents: PropTypes.object,
};

export default GridContainer;
